"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "isernia": {
    "d8337386": [{
      "hkey": "d724aa3f",
      "slug": "isernia",
      "name": "Isernia",
      "primary": true,
      "skipSearch": false
    }],
    "periferia": [{
      "hkey": "d724aa3f",
      "slug": "isernia",
      "name": "Isernia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d749203c": [{
      "hkey": "4b9fa27a",
      "slug": "nunziatella-san-lazzaro",
      "name": "Nunziatella-San Lazzaro",
      "primary": true,
      "skipSearch": false
    }],
    "san-lazzaro": [{
      "hkey": "4b9fa27a",
      "slug": "nunziatella-san-lazzaro",
      "name": "Nunziatella-San Lazzaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "24057b95": [{
      "hkey": "1fc8ed93",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "semicentro": [{
      "hkey": "1fc8ed93",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "isernia"
    }]
  }
};
exports["default"] = _default;